import React, { Component } from 'react';
import { withRouter } from "util/withRouter";

import {
  InstantSearch
} from 'react-instantsearch-dom';

import algoliasearch from 'algoliasearch/lite';
import AutoComplete from './AutoComplete';
import { algolia } from 'util/config';

/************Alogolia APi Key */

const algoliaClient = algoliasearch(
  algolia.applicationID,
  algolia.searchAPIKey
);

const searchClient = {
  search(requests) {
    const shouldSearch = requests.some(({ params: { query } }) => query !== '');
    if (shouldSearch) {
      return algoliaClient.search(requests);
    }
    return Promise.resolve({
      results: [{ hits: [] }],
    });
  },
  searchForFacetValues: algoliaClient.searchForFacetValues,
};

class SearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      placeholder: 'Ex:comédien,amical,documentaire.......',
    };
    this.handleChangealgolia = this.handleChangealgolia.bind(this)
  }


  handleChangealgolia(event) {
    this.setState({ Handlevalue: event.target.value });
  }

  render() {
    const params = new URLSearchParams(window.location.search);
    
    var defaultRefinement = '';
    if (params.has("keyword")) {
      defaultRefinement = params.get('keyword');
    }

    return (
      <InstantSearch
        indexName={algolia.indexAutoCompleteName}
        searchClient={searchClient}
        refresh={true}
      >
        <AutoComplete
          defaultRefinement={defaultRefinement}
          onSuggestionSelected={this.onSuggestionSelected}
          displayOn={this.props.displayOn}
        />
      </InstantSearch>
    )
  }
}

export default withRouter(SearchForm);